// Anything can be thrown (strings, frozen errors, objects with throwing getters/toString).
// Callers use this on the crash screen itself and from error boundaries, so it must never throw.
export function getCrashErrorAttributes(crashError) {
  if (!crashError) return {};
  try {
    const { name, message, componentStack } = crashError;
    return {
      errorName: typeof name === 'string' ? name : undefined,
      errorMessage: String(message ?? crashError).slice(0, 200),
      componentStack:
        typeof componentStack === 'string'
          ? componentStack
              .split('\n')
              .filter(Boolean)
              .slice(0, 3)
              .map(line => line.trim())
              .join(' | ')
          : undefined,
    };
  } catch {
    return { errorMessage: 'unserializable crash error' };
  }
}
